module.exports = __webpack_public_path__ + "static/media/DancingScript-VariableFont_wght.d3bebba9.ttf";


//////////////////
// WEBPACK FOOTER
// ./src/fonts/DancingScript-VariableFont_wght.ttf
// module id = 39
// module chunks = 0